import { AxiosInstance } from "axios"
import { MeetingServiceOrder } from "../../../../merchant/merchant/production/meetingService/meetingServiceTypes"

export enum UpcomingOrdersMeetingService {
    UPCOMING_ORDERS_MEETING_SERVICE = "upcoming-orders-meeting-service",
}

export type FetchMeetingServiceResponse = Readonly<{
    orders: MeetingServiceOrder[]
}>

type FetchMeetingServiceParams = Readonly<{
    userId: number
    period?: string
    startDate?: string
    endDate?: string
}>

export async function fetchMeetingServiceForUser(
    { userId, ...params }: FetchMeetingServiceParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchMeetingServiceResponse> {
    const url = `/users/${userId}/upcoming/meetingService`

    const response = await axios.get(url, {
        params,
        signal,
    })

    return response.data
}
